import { z } from "zod";

export const imagesSchema = z.object({
  small: z.url().nullable(),
  medium: z.url().nullable(),
  large: z.url().nullable(),
  fallback: z.url().nullable(),
  color_hex: z
    .string()
    .regex(/#[0-9A-Fa-f]{6,8}/)
    .nullable()
    .optional(),
});

export type Images = z.infer<typeof imagesSchema>;
